import type { JSX } from 'react'

import { IconProps } from './IconProps'

export const CheckBoxEditActiveIcon = (props: IconProps): JSX.Element => {
  const width = props.width || '24'
  const height = props.height || '24'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M8.44444 12H15.5556M7.55556 20H16.4444C18.4081 20 20 18.4081 20 16.4444V7.55556C20 5.59188 18.4081 4 16.4444 4H7.55556C5.59188 4 4 5.59188 4 7.55556V16.4444C4 18.4081 5.59188 20 7.55556 20Z'
        stroke='var(--text-black)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
